import { createContext, useReducer } from "react";
import React from 'react';
import AuthContextReducer from "./auth-context-reducer";
import { USER_KEY, ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "./auth-context-vars";
import axios from "axios";
import { AxiosInstance } from "axios";
import { useNavigate } from "react-router-dom";
import { SERVER_URL, REFRESH_TOKEN_API_PATH } from "../../../../global_vars";

interface AuthContextProps {
    children: React.ReactNode,
}

// LoginContextState
export interface AuthContextState {
    user: string,
    canLogin: boolean,
    axiosRequestHelper: AxiosInstance,
    login: (user: string, accessToken: string, refreshToken: string) => void,
    logout: () => void,
}

// Token Regenerate Response
interface TokenRegenerateResponse {
    accessToken: string;
    refreshToken: string;
}

// Initializing context
export const AuthContext = createContext<AuthContextState>({
    user: "",
    canLogin: false,
    axiosRequestHelper: axios.create({}),
    login: (user: string, accessToken: string, refreshToken: string) => {},
    logout: () => {},
});


function AuthContextProvider(props: AuthContextProps) {

    

    const convertNullToString = (s: string|null): string => {
        return s === null ?  "" : s;

    }

    const login = (user: string, accessToken: string, refreshToken: string) => {
        console.log("log in called in auth context");
        dispatch({
            type: "LOGIN",
            payload: {
                user: user,
                accessToken: accessToken,
                refreshToken: refreshToken,
            },
        });
        console.log("Login state updated");
    }

    const logout = () => {
        console.log("called logout");
        dispatch({type: "LOGOUT"});
    }

    const isJWTTokenValid = (token: string): boolean => {
        if(token === "") {
            return false;
        }
        const currExipryTimeStamp: number = JSON.parse(atob(token.split('.')[1])).exp * 1000;
        return currExipryTimeStamp > Date.now();
    }

    const getAccessToken = (): string => {
        return convertNullToString(localStorage.getItem(ACCESS_TOKEN_KEY));
    }

    const setAccessToken = (token: string) => {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
    }

    const getRefreshToken = (): string => {
        return convertNullToString(localStorage.getItem(REFRESH_TOKEN_KEY));
    }

    const setRefreshToken = (token: string) => {
        localStorage.setItem(REFRESH_TOKEN_KEY, token);
    }


    const updateAccessTokenSyncronous = async () => {
        const refreshToken = getRefreshToken();
        const accessToken = getAccessToken();
        if(isJWTTokenValid(refreshToken)) {
            if(!isJWTTokenValid(accessToken)) {
                try {
                    const resp = await fetch(SERVER_URL+REFRESH_TOKEN_API_PATH, {
                        method: "POST",
                        headers: {
                            "Authorization": "Bearer "+refreshToken,
                        },
                    });
                    const data = await resp.json();
                    if(data.accessToken && data.refreshToken) {
                        setAccessToken(data.accessToken);
                        setRefreshToken(data.refreshToken);
                    } else {
                        console.log("Received empty data in response while regenrating token: ", data);
                        dispatch({type: "LOGOUT"});
                        navigate("/login");
                    }
                } catch(error) {
                    console.log("Error occured while regenarating access token: ", error);
                    dispatch({type: "LOGOUT"});
                    navigate("/login");
                } 
            } 
        } else {
            console.log("JWT refresh is invalid: ", refreshToken);
            dispatch({type: "LOGOUT"});
            navigate("/login");
        }
    }

    const axiosRequestHelper = (): AxiosInstance => {
        const axiosRequestHelperObj = axios.create({
            baseURL: SERVER_URL,
            // timeout: 10000,
        });

        axiosRequestHelperObj.interceptors.request.use(async (axiosConfig) => {
            await updateAccessTokenSyncronous();
            // axiosConfig.headers.Authorization = "Bearer " + getAccessToken();
            axiosConfig.headers['X-Jwt-Token'] = getAccessToken();
            return axiosConfig;
        
        }, (error) => {
        
        });


        return axiosRequestHelperObj;
    }

    const navigate = useNavigate();
    const [loginState, dispatch] = useReducer(AuthContextReducer, {
            user: convertNullToString(localStorage.getItem(USER_KEY)),
            canLogin: isJWTTokenValid(convertNullToString(localStorage.getItem(REFRESH_TOKEN_KEY))),
            axiosRequestHelper: axiosRequestHelper(), 
            login: login,
            logout: logout,
        });



    return (
        <AuthContext.Provider value={loginState}>
            {props.children}
        </AuthContext.Provider>
    );
}


export default AuthContextProvider;


